export const TACK_NOTIFICATION_DETAILS_RESET = 'user.TACK_NOTIFICATION_DETAILS_RESET';
export const TACK_NOTIFICATION_DETAILS_MARKED_AS_READ = 'user.TACK_NOTIFICATION_DETAILS_MARKED_AS_READ';
export const TACK_NOTIFICATION_DETAILS_RETRIEVED = 'user.TACK_NOTIFICATION_DETAILS_RETRIEVED';
export const TACK_NOTIFICATION_DETAILS_RETRIEVING = 'user.TACK_NOTIFICATION_DETAILS_RETRIEVING';
export const TACK_NOTIFICATION_DETAILS_ERROR = 'user.TACK_NOTIFICATION_DETAILS_ERROR';



// WEBPACK FOOTER //
// ./src/stores/tack_notification_details/action_types.js